module.exports = __webpack_public_path__ + "cff2e59855afbc6e9560939af4987aec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/microphone.png
// module id = 2683
// module chunks = 0